import { render, staticRenderFns } from "./EditBuilding.vue?vue&type=template&id=7b88fe92&scoped=true"
import script from "./EditBuilding.js?vue&type=script&lang=js&external"
export * from "./EditBuilding.js?vue&type=script&lang=js&external"
import style0 from "./EditBuilding.css?vue&type=style&index=0&id=7b88fe92&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b88fe92",
  null
  
)

export default component.exports